<template>
  <div :class="modalTheme">
    <b-row class="justify-content-center" v-if="userStore.isAuthenticated" style="margin-top: 66px">
      <b-col cols="3"> <WelcomeName /></b-col>
      <b-col cols="3">
        <b-button :class="modalTheme" size="sm" @click="login" v-if="!userStore.isAuthenticated">Sign In</b-button>
        <b-button :class="modalTheme" size="sm" @click="handleLogout" v-else>Sign Out</b-button>
      </b-col>
    </b-row>

    <b-row class="justify-content-center" :class="modalTheme" v-else>
      <b-card no-body :class="modalTheme" style="margin-top: 150px; width: 850px; border-radius: 9px">
        <!-- <h6>modalTheme: {{ modalTheme }}</h6> -->
        <!-- <b-card-header header-tag="header" class="p-1 medCard" role="tab" :class="modalTheme">
        <b-button :class="modalTheme" block v-b-toggle.accordion-1 variant="primary-green">Rx History</b-button>
      </b-card-header> -->
        <template #header>
          <h3>*** WARNING ***</h3>
        </template>

        <b-card-body :class="modalTheme">
          <h6>
            THIS SYSTEM IS THE PROPERTY OF INNOVARE HEALTH ADVOCATES.
            <br />
            ACCESS TO THIS SYSTEM IS RESTRICTED TO AUTHORIZED USERS ONLY.
            <br />
            IF YOU HAVE ENTERED THIS SYSTEM BY MISTAKE, PLEASE CLICK THE “LEAVE” BUTTON BELOW.
          </h6>
        </b-card-body>
        <b-card-footer>
          <b-row>
            <b-col class="text-center">
              <b-button :class="modalTheme" size="sm" style="width: 140px" @click="redirectToGoogle">Leave</b-button>
            </b-col>
            <b-col class="text-center">
              <b-button :class="modalTheme" size="sm" style="width: 140px" @click="login">Login</b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-row>
  </div>

  <div class="logo-container">
    <img class="img-fluid center" :src="logoNObg" />
  </div>

  <div v-if="devCalls">
    data test buttons
    <b-button :class="modalTheme" size="sm" @click="fetchUserAPIData()" :disabled="loading">Get fetchUserData Data</b-button>
    <!-- <b-button :class="modalTheme" size="sm" @click="fetchUserDataXXX()" :disabled="loading">Get userApiXXX Data</b-button> -->
    <div v-if="loading">Loading...</div>
    <div style="height: 111px; overflow-y: auto">
      <pre v-if="userData" style="color: cyan">{{ userData }}</pre>
      <div v-if="error" style="color: red">{{ error }}</div>
    </div>
    <div style="height: 111px; overflow-y: auto">
      <pre v-if="userData2" style="color: yellow">{{ userData2 }}</pre>
      <div v-if="error" style="color: red">{{ error }}</div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import WelcomeName from "@/modules/User/WelcomeName.vue";
import logoNObg from "@/assets/images/innovare-logoNObg.png";

import { fetchUserData } from "@/api/userApi";

import { fetchActiveDirectoryUsers } from "@/api/adminApi";
import { getToken, logout, login } from "../config/authService";

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(true);
const devCalls = ref(false);
const show = ref(false);

const userData = ref(null);
const userData2 = ref(null);
const loading = ref(false);
const error = ref("");

function handleLogout() {
  logout();
  userStore.isAuthenticated = false;
  // userStore.accessToken = null
}

async function fetchUserAPIData() {
  loading.value = true;
  error.value = "";
  try {
    userData2.value = await fetchUserData(); //userData.value = await fetchUserData();

    // console.log("fetchUserAPIData() : userData2.value", userData2.value);
  } catch (e) {
    error.value = "[UserData.vue] Failed to load user data. ${e}";
  } finally {
    loading.value = false;
  }
}

// async function fetchUserDataXXX() {
//   loading.value = true;
//   error.value = "";
//   try {
//     userData.value = await getUserData();
//     //userData.value = await fetchUserData();
//   } catch (e) {
//     error.value = "[UserData.vue] Failed to load user data. ${e}";
//   } finally {
//     loading.value = false;
//   }
// }
function redirectToGoogle() {
  window.location.href = "https://www.google.com";
}
onMounted(async () => {
  // console.log("onMounted() :      Temp LOGIN page  >>>>");
  // try {
  //   // Attempt silent login on component mount
  //   const token = await getToken();
  //   if (token) {
  //     console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:   FOUND");
  //     // // console.log(" >>>>>>>>>>>>>>>>>>>>>>>                                                        [TheWelcome.vue] Silent login successful, token:", token);
  //     //await getUserData(); // Only call if authenticated
  //   }
  // } catch (e) {
  //   console.warn("                    Silent login failed:", e);
  //   // Optionally, handle errors or show a message
  // }
});
</script>

<style lang="scss">
.center {
  display: block;
  margin-left: auto;

  margin-right: auto;
  width: 33%;
}
.logo-container {
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.responsive-logo {
  max-width: 100%;
  height: auto;
  width: 40%;

  // Responsive scaling for different screen sizes
  @media (max-width: 1200px) {
    max-width: 600px;
  }

  @media (max-width: 992px) {
    max-width: 500px;
  }

  @media (max-width: 768px) {
    max-width: 400px;
  }

  @media (max-width: 576px) {
    max-width: 300px;
  }

  @media (max-width: 400px) {
    max-width: 250px;
  }
}
</style>
